import React from 'react';

import { ReactComponent as AssassinSymbol } from '../assets/assassin.svg';

type Props = {
  value: number[];
  onClick: (event: React.MouseEvent<HTMLButtonElement>) => void;
};

/**
 * The aggregation of the result of all dice rolled,
 *  includes the roll button
 * @param props
 */
const ResultRow: React.FC<Props> = (props) => {
  return (
    <div className="row row--black">
      <span className="row__numbers">
        <span>
          Result:
          {' '}
          {props.value[0]}
        </span>
        <div className="row__icon__container">
          <span className="row__icon__holder">
            <span>{props.value[1]}</span>
            <AssassinSymbol />
          </span>
        </div>
      </span>
      <button
        className="button"
        onClick={props.onClick}
      >
        Roll!
      </button>
    </div>
  );
};

export default ResultRow;